/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userConglomerateNotificationPreferences.internal

import features.userConglomerateNotificationPreferences.models.NotificationSettingsModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest

internal class GetConglomerateNotificationPreferencesRequest : NetworkRequest() {

    suspend fun getConglomerateNotificationPreferences(
        overrideHeaders: Map<String, String>? = null,

    ): IOResult<NotificationSettingsModel> {
        return safeNetworkCall {
            get(
                endpoint = GetConglomerateNotificationPreferencesEndpoint,
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
